// extracted by mini-css-extract-plugin
export var container = "_8e-0";
export var error = "_8e-9";
export var label = "_8e-5";
export var light = "_8e-6";
export var md = "_8e-3";
export var sm = "_8e-2";
export var thin = "_8e-8";
export var thinBold = "_8e-7";
export var vertical = "_8e-4";
export var xs = "_8e-1";